import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function itemDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/item/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
